"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _useDebounce = require("../hooks/useDebounce");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var dot = function dot() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transparent';
  return {
    alignItems: 'center',
    display: 'flex',
    ':before': {
      backgroundColor: "".concat(color, "35"),
      borderRadius: 15,
      border: "1px solid ".concat(color),
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 15,
      width: 15
    }
  };
};

var SelectGeneric = function SelectGeneric(_ref) {
  var onClear = _ref.onClear,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      remove = _ref.remove,
      fetchData = _ref.fetchData,
      async = _ref.async,
      label = _ref.label,
      customLabel = _ref.customLabel,
      options = _ref.options,
      isDisabled = _ref.isDisabled,
      isInvalid = _ref.isInvalid,
      errors = _ref.errors,
      placeholder = _ref.placeholder,
      isMulti = _ref.isMulti,
      className = _ref.className,
      _onChange = _ref.onChange,
      heigthSelect = _ref.heigthSelect,
      paddingIndicator = _ref.paddingIndicator,
      withSelect = _ref.withSelect,
      onFocus = _ref.onFocus,
      _noOptionsMessage = _ref.noOptionsMessage,
      optionMapper = _ref.optionMapper,
      _loadingMessage = _ref.loadingMessage,
      defaultValueOneOption = _ref.defaultValueOneOption,
      checkListOptions = _ref.checkListOptions,
      hideSelectedOptions = _ref.hideSelectedOptions,
      allowSelectAll = _ref.allowSelectAll,
      allOption = _ref.allOption,
      closeMenuOnSelect = _ref.closeMenuOnSelect,
      showAllValues = _ref.showAllValues,
      variantOptions = _ref.variantOptions,
      clearable = _ref.clearable,
      moreActions = _ref.moreActions,
      showTooltipValue = _ref.showTooltipValue,
      placementTooltipValue = _ref.placementTooltipValue,
      menuPlacement = _ref.menuPlacement,
      menuPosition = _ref.menuPosition,
      dropdownIcon = _ref.dropdownIcon,
      withDots = _ref.withDots,
      isPill = _ref.isPill,
      maxMenuHeight = _ref.maxMenuHeight;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      fetchedOptions = _useState2[0],
      setFetchedOptions = _useState2[1];

  var customStyles = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: withSelect
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        minHeight: heigthSelect,
        borderColor: !isInvalid ? '#ddd' : 'red',
        borderRadius: isPill ? heigthSelect : provided.borderRadius
      });
    },
    menu: function menu(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        width: state.selectProps.width
      });
    },
    indicatorsContainer: function indicatorsContainer() {
      return {
        // none of react-select's styles are passed to <Control />
        '& div': {
          padding: paddingIndicator,
          display: 'inline-block'
        }
      };
    },
    option: function option(styles, _ref2) {
      var data = _ref2.data;
      return withDots ? _objectSpread(_objectSpread({}, styles), dot(data.color)) : styles;
    },
    singleValue: function singleValue(styles, _ref3) {
      var data = _ref3.data;
      return withDots ? _objectSpread(_objectSpread({}, styles), dot(data.color)) : styles;
    },
    multiValue: function multiValue() {
      return {
        backgroundColor: variantOptions === 'info' ? '#e5f7ff' : '#F7F7F7',
        color: '#575757',
        borderRadius: '30px',
        border: variantOptions === 'info' ? '' : '1px solid #999999',
        display: 'flex',
        alignItems: 'center',
        margin: '2px',
        // Para que no se corte el label
        // en caso de que sea largo
        paddingLeft: 8,
        '.css-12jo7m5': {
          whiteSpace: 'normal'
        }
      };
    },
    multiValueRemove: function multiValueRemove() {
      return {
        width: 'auto',
        color: '#999999',
        border: '1px solid #999999',
        borderRadius: '30px',
        opacity: 0.7,
        display: 'flex',
        marginLeft: '5px',
        marginRight: '5px'
      };
    }
  };

  var dataMapper = function dataMapper(optionsData) {
    return optionsData.length ? optionsData.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        value: option[optionMapper.value],
        label: option[optionMapper.label]
      });
    }) : [];
  };

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      asyncSelect = _useState4[0],
      setAsyncSelect = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var debouncedSelect = (0, _useDebounce.useDebounce)(asyncSelect);

  var handleAsyncOnInputChange = function handleAsyncOnInputChange(value) {
    setAsyncSelect(value);
  };

  var handleAsyncOnChange = function handleAsyncOnChange(event) {
    _onChange(event);

    setFetchedOptions([]);
  };

  (0, _react.useEffect)(function () {
    var fetchOptions = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _options;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!debouncedSelect) {
                  _context.next = 7;
                  break;
                }

                setIsLoading(true);
                _context.next = 4;
                return fetchData(debouncedSelect);

              case 4:
                _options = _context.sent;
                setFetchedOptions(dataMapper(_options));
                setIsLoading(false);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchOptions() {
        return _ref4.apply(this, arguments);
      };
    }();

    fetchOptions();
  }, [debouncedSelect]);
  var mappedData = dataMapper(options);
  var onlyOneOption = mappedData.length === 1 && defaultValueOneOption;
  var data = onlyOneOption ? mappedData[0] : value;

  var mapperValue = function mapperValue() {
    if (value) {
      if (Array.isArray(value)) {
        return value.map(function (val) {
          return val.label;
        }).join(',');
      }

      return value.label;
    }
  };

  var popoverValue = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover-".concat(name, "-tooltip")
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Body, {
    style: {
      padding: ' 0.25rem 0.5rem'
    }
  }, showTooltipValue ? mapperValue() : null));

  var renderSelects = function renderSelects() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, async && /*#__PURE__*/_react.default.createElement("div", {
      className: "generic-select async ".concat(className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        width: withSelect
      }
    }, customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, customLabel), label && !customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), moreActions ? moreActions : null), /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      className: "select-async",
      components: {
        DropdownIndicator: DropdownIndicator
      },
      defaultOptions: fetchedOptions,
      errors: errors,
      hideSelectedOptions: hideSelectedOptions,
      isClearable: true,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      isMulti: isMulti,
      onBlur: function onBlur() {
        return setFetchedOptions([]);
      },
      label: label,
      loadingMessage: function loadingMessage() {
        return _loadingMessage;
      },
      maxMenuHeight: maxMenuHeight,
      menuPlacement: menuPlacement,
      onClear: onClear,
      menuPosition: menuPosition,
      name: name,
      noOptionsMessage: function noOptionsMessage() {
        if (isLoading) return _loadingMessage;
        if (!isLoading && !fetchedOptions.length) return _noOptionsMessage;
        return _noOptionsMessage;
      },
      onChange: handleAsyncOnChange,
      onFocus: onFocus,
      onInputChange: handleAsyncOnInputChange,
      options: dataMapper(fetchedOptions),
      placeholder: placeholder,
      remove: remove,
      styles: customStyles,
      value: data,
      width: withSelect
    })), checkListOptions && /*#__PURE__*/_react.default.createElement("div", {
      className: "generic-select ".concat(className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        width: withSelect
      }
    }, customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, customLabel), label && !customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), moreActions ? moreActions : null), /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      menuPosition: menuPosition,
      menuPlacement: menuPlacement,
      styles: customStyles,
      width: withSelect,
      name: name,
      label: label,
      onClear: onClear,
      placeholder: placeholder,
      isMulti: true,
      value: data && data.length === options.length && !showAllValues ? [{
        value: '*',
        label: 'Todos'
      }] : data,
      isInvalid: isInvalid,
      isDisabled: isDisabled,
      errors: errors,
      options: data && data.length === options.length ? [] : dataMapper([allOption].concat(_toConsumableArray(options))),
      onChange: function onChange(selected) {
        if (selected && selected.length) {
          var isAllOptions = selected.some(function (sel) {
            return sel.value === allOption.id;
          });
          if (isAllOptions) return _onChange(dataMapper(options));
        }

        return _onChange(dataMapper(selected));
      },
      onFocus: onFocus,
      noOptionsMessage: function noOptionsMessage() {
        return _noOptionsMessage;
      },
      components: {
        Option: Option,
        DropdownIndicator: DropdownIndicator
      },
      hideSelectedOptions: hideSelectedOptions,
      allowSelectAll: allowSelectAll,
      closeMenuOnSelect: closeMenuOnSelect,
      maxMenuHeight: maxMenuHeight
    })), !checkListOptions && !async && /*#__PURE__*/_react.default.createElement("div", {
      className: "generic-select ".concat(className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-between align-items-center",
      style: {
        width: withSelect
      }
    }, customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, customLabel), label && !customLabel && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), moreActions ? moreActions : null), /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
      menuPosition: menuPosition,
      menuPlacement: menuPlacement,
      styles: customStyles,
      width: withSelect,
      name: name,
      label: label,
      placeholder: placeholder,
      isMulti: isMulti,
      value: data,
      onClear: onClear,
      isInvalid: isInvalid,
      isDisabled: isDisabled,
      errors: errors,
      options: dataMapper(options),
      onChange: _onChange,
      onFocus: onFocus,
      hideSelectedOptions: hideSelectedOptions,
      noOptionsMessage: function noOptionsMessage() {
        return _noOptionsMessage;
      },
      isClearable: clearable,
      components: {
        DropdownIndicator: DropdownIndicator
      },
      maxMenuHeight: maxMenuHeight
    })));
  };

  var Option = function Option(propsOptions) {
    var isSelected = propsOptions.isSelected,
        labelOption = propsOptions.label;
    return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, propsOptions, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      checked: isSelected,
      onChange: function onChange() {
        return null;
      },
      className: "check-option"
    }), /*#__PURE__*/_react.default.createElement("span", null, labelOption));
  };

  var DropdownIndicator = function DropdownIndicator(props) {
    return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, dropdownIcon);
  };

  (0, _react.useEffect)(function () {
    if (onlyOneOption) {
      _onChange(data);
    }
  }, [options]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showTooltipValue && value ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    id: "overlay-".concat(name, "-tooltip"),
    trigger: ['hover', 'focus'],
    placement: placementTooltipValue,
    overlay: popoverValue,
    rootClose: true
  }, /*#__PURE__*/_react.default.createElement("div", null, renderSelects()))) : renderSelects(), /*#__PURE__*/_react.default.createElement("div", {
    className: "feedback ".concat(!isInvalid && 'hide')
  }, isInvalid ? errors : placeholder));
};

SelectGeneric.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]),
  onClear: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  label: _propTypes.default.string,
  customLabel: _propTypes.default.element,
  placeholder: _propTypes.default.string,
  errors: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.arrayOf(_propTypes.default.object)]),
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  remove: _propTypes.default.arrayOf(_propTypes.default.object),
  isDisabled: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  async: _propTypes.default.bool,
  isMulti: _propTypes.default.bool,
  fetchData: _propTypes.default.func,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  heigthSelect: _propTypes.default.number,
  paddingIndicator: _propTypes.default.number,
  withSelect: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  onFocus: _propTypes.default.func,
  noOptionsMessage: _propTypes.default.string,
  optionMapper: _propTypes.default.object,
  loadingMessage: _propTypes.default.string,
  defaultValueOneOption: _propTypes.default.bool,
  checkListOptions: _propTypes.default.bool,
  allOption: _propTypes.default.shape({
    id: _propTypes.default.string,
    nombre: _propTypes.default.string
  }),
  hideSelectedOptions: _propTypes.default.bool,
  allowSelectAll: _propTypes.default.bool,
  closeMenuOnSelect: _propTypes.default.bool,
  showAllValues: _propTypes.default.bool,
  variantOptions: _propTypes.default.oneOf(['light', 'info']),
  clearable: _propTypes.default.bool,
  moreActions: _propTypes.default.element,
  placementTooltipValue: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
  showTooltipValue: _propTypes.default.bool,
  menuPosition: _propTypes.default.oneOf(['absolute', 'fixed']),
  menuPlacement: _propTypes.default.oneOf(['bottom', 'auto', 'top']),
  maxMenuHeight: _propTypes.default.number
};
SelectGeneric.defaultProps = {
  onClear: function onClear() {},
  label: '',
  customLabel: null,
  placeholder: '',
  errors: '',
  defaultValue: {},
  options: [],
  remove: [],
  isDisabled: false,
  isInvalid: false,
  async: false,
  isMulti: false,
  fetchData: function fetchData() {},
  className: '',
  onChange: function onChange() {},
  heigthSelect: 30,
  paddingIndicator: 8,
  withSelect: 279.25,
  onFocus: function onFocus() {},
  noOptionsMessage: 'Sin opciones',
  optionMapper: {
    value: 'id',
    label: 'nombre'
  },
  loadingMessage: 'Cargando ...',
  defaultValueOneOption: true,
  value: null,
  checkListOptions: false,
  allOption: {
    id: '*',
    nombre: 'Seleccionar todos'
  },
  hideSelectedOptions: true,
  allowSelectAll: true,
  closeMenuOnSelect: false,
  showAllValues: true,
  variantOptions: 'light',
  clearable: false,
  moreActions: null,
  showTooltipValue: false,
  placementTooltipValue: 'bottom',
  menuPosition: 'absolute',
  menuPlacement: 'auto',
  maxMenuHeight: 200
};
var _default = SelectGeneric;
exports.default = _default;